document.addEventListener('DOMContentLoaded', function () {
  var options = {
    align: 'start',
    skipSnaps: false,
    dragFree: false,
    containScroll: 'keepSnaps',
  };

  var emblaNode = document.querySelector('.article-sidebar__carousel');
  if (!emblaNode) return;

  var viewportNode = emblaNode.querySelector('.embla__viewport');
  var embla = EmblaCarousel(viewportNode, options);

  var dotsNode = emblaNode.querySelector('.embla__dots');
  var dotsArray = generateDots(dotsNode, embla.scrollSnapList());

  var selectedDotIndex = 0;
  dotsArray[selectedDotIndex].classList.add('embla__dot--selected');

  embla.on('select', function () {
    var previousDotIndex = selectedDotIndex;
    selectedDotIndex = embla.selectedScrollSnap();
    dotsArray[previousDotIndex].classList.remove('embla__dot--selected');
    dotsArray[selectedDotIndex].classList.add('embla__dot--selected');
  });

  dotsArray.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      embla.scrollTo(index);
    });
  });

  // Video handling
  const videoContainer = document.querySelector('.article-featured-video');
  if (videoContainer) {
    const video = videoContainer.querySelector('video');
    const playButton = videoContainer.querySelector(
      '.article-featured-video__play'
    );
    const overlay = videoContainer.querySelector(
      '.article-featured-video__overlay'
    );

    function playVideo() {
      video.play();
      playButton.style.display = 'none';
      overlay.style.display = 'none';
    }

    function pauseVideo() {
      video.pause();
      playButton.style.display = 'flex';
      overlay.style.display = 'block';
    }

    playButton.addEventListener('click', function () {
      playVideo();
    });

    video.addEventListener('click', function () {
      if (video.paused) {
        playVideo();
      } else {
        pauseVideo();
      }
    });

    video.addEventListener('pause', function () {
      pauseVideo();
    });
  }
});

function generateDots(dotsNode, scrollSnaps) {
  var dotsHTML = scrollSnaps.reduce(function (acc) {
    return acc + '<button class="embla__dot" type="button"></button>';
  }, '');
  dotsNode.innerHTML = dotsHTML;
  return [].slice.call(dotsNode.querySelectorAll('.embla__dot'));
}

document.addEventListener('DOMContentLoaded', function () {
  const articleReadMoreButtons = document.querySelectorAll('.article-author__read-more');

  articleReadMoreButtons.forEach(function (articleReadMoreButton) {
    articleReadMoreButton.addEventListener('click', function () {
      articleReadMoreButton.textContent =
        articleReadMoreButton.textContent === 'Read more' ? 'Read less' : 'Read more';
      const articleReadMoreText = articleReadMoreButton.previousElementSibling;
      articleReadMoreText.classList.toggle('is-expanded');
    });
  });
});


if (!customElements.get('copy-button')) {
  class CopyButton extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener('click', this.copyToClipboard.bind(this));
    }

    copyToClipboard() {
      const url = this.dataset.url;
      const originalMsg = this.querySelector('.copy-msg');
      const successMsg = this.querySelector('.copy-success-msg');

      if (!url || !navigator.clipboard) return;

      navigator.clipboard.writeText(url).then(() => {
        if (originalMsg && successMsg) {
          originalMsg.style.display = 'none';
          successMsg.style.display = 'inline';

          setTimeout(() => {
            originalMsg.style.display = 'inline-flex';
            successMsg.style.display = 'none';
          }, 2000);
        }
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }

  customElements.define('copy-button', CopyButton, { extends: 'button' });
}